import { gql } from '@apollo/client';

const userQuery = gql`
  query getUser($publicId: ID!) {
    account(publicId: $publicId) {
      publicId
      name
      rating
      level
      countryCode
      avatarId
      subscriptionExpireTimestamp
      clan {
        name
        tag
        tagColor
        iconId
        flagId
        itemIds
      }
      stats {
        kills
        deaths
        wins
        matches
        totalTime
        killsByType {
          primaryWeapon
          secondaryWeapon
          melee
          explosive
          physics
          vehicle
          machineGun
          assists
          byWeaponClass {
            weaponClass
            kills
          }
        }
      }
      patches {
        id
        count
      }
      presets {
        hero {
          id
          level
          skinId
          talentIds
        }
        primaryWeapon {
          id
          skinId
          collectibleId
          level
          moduleIds
        }
        secondaryWeapon {
          id
          skinId
          collectibleId
          level
          moduleIds
        }
        firstAbility {
          id
          level
        }
        secondAbility {
          id
          level
        }
      }
    }
  }
`;

export { userQuery };
